import useQueryValue from './useQueryValue';

export default function useQueryFilter(name: string): string[] | null {
  const queryValue = useQueryValue(name);

  return queryValue ? queryValue.split(',') : null;
}
